import React from 'react';

const FloorNavigation = ({ activeFloor, setActiveFloor }) => (
  <div className="floor-nav">
    {[...Array(14)].map((_, i) => (
      <button
        key={i}
        className={`floor-pill ${activeFloor === i + 1 ? 'active' : ''}`}
        onClick={() => setActiveFloor(i + 1)}
      >
        F-{i + 1}
      </button>
    ))}
  </div>
);

export default FloorNavigation;
